import { createBrowserRouter, RouterProvider, Navigate, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import NavDrawer from "./components/navDrawer/NavDrawer.jsx";
import LearnerDashboard from "./components/userComponents/LearnerDashboard";
import MarkAttendance from "./components/attendance/MarkAttendance.jsx";
import TodaysPractice from "./components/todaysPractice/TodaysPractice.jsx";
import ModuleModal from "./components/allCodingPractices/ModuleModal.jsx";
import DailyPracticeNotes from "./components/dailynotes/DailyPracticeNotes.jsx";
import AllTopics from "./components/allTopics/AllTopics";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (location.pathname.startsWith("/learner/attendance/") && location.pathname.endsWith("/qrcode")) {
    const today = new Date().toLocaleDateString("en-CA"); 
    const attendancePath = {
      attendancePath:location.pathname,
      storedAt: today
  };

    localStorage.setItem("attendancePath", JSON.stringify(attendancePath));
  }
  else if (location.pathname.startsWith("/learner/labdailypractices/") && location.pathname.endsWith("/qrcode")) {
    localStorage.setItem("practicePath", location.pathname);
  }
  else if (location.pathname.startsWith("/learner/dailynotes/") && location.pathname.endsWith("/qrcode")) {
    localStorage.setItem("notesPath", location.pathname);
  }

  return token ? children : <Navigate to="/" replace />;
};

function RoutingModule() {

  const AppRoutes = createBrowserRouter([
    { path: "/", element: <Login /> },
    {
      path: "/learner",
      element: (
        <PrivateRoute>
          <NavDrawer />
        </PrivateRoute>
      ),
      children: [
        { path: "attendance/:attendanceCode/qrcode", element: <MarkAttendance /> },
        { path: "attendance", element: <MarkAttendance /> },
        { path: "labdailypractices/:practice_code/qrcode", element: <TodaysPractice /> },
        { path: "labdailypractices", element: <TodaysPractice /> },
        { path: "dailynotes/:notes_code/qrcode", element: <DailyPracticeNotes /> },
        { path: "dailynotes", element: <DailyPracticeNotes /> },
        { path: "all-topics", element: <AllTopics /> },
        {
          path: "all-coding-practices", element: <ModuleModal />
          // element: isMobile ? <ModuleModal /> : <AllCodingPractice />,
        },
        { path: "learner-dashboard", element: <LearnerDashboard /> },
      ],
    },
  ]);

  return <RouterProvider router={AppRoutes} />;
}

export default RoutingModule;
